import { takeEvery } from 'redux-saga/effects';

import sagaRelationToFacility, { action as relationToFacilityAction } from './sagaRelationToFacility';

export default () => function* () {
  yield takeEvery(relationToFacilityAction, sagaRelationToFacility);
};
